/**
 * @generated SignedSource<<f1207921e52de4d1e9ad3a451943003e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductizedServiceWorkWithMe_userProfile$data = {
  readonly generalInquiryCtaIsVisible: boolean;
  readonly " $fragmentType": "ProductizedServiceWorkWithMe_userProfile";
};
export type ProductizedServiceWorkWithMe_userProfile$key = {
  readonly " $data"?: ProductizedServiceWorkWithMe_userProfile$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductizedServiceWorkWithMe_userProfile">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductizedServiceWorkWithMe_userProfile",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "generalInquiryCtaIsVisible",
      "storageKey": null
    }
  ],
  "type": "UserProfile",
  "abstractKey": null
};

(node as any).hash = "cd83cdc58b9cd6f57de530abc30ad161";

export default node;
